<template>
  <owal-modal
    :show="show"
    class="owal camera picker modal"
  >
    <div
      slot="content"
      class="owal camera picker panel"
    >
      <div
        class="owal panel header bar"
      >
        <div
          class="owal panel header title bar"
        >
          <span
            class="owal panel header left button"
          />
          <h3
            class="title"
          >
            Filter
          </h3>
          <span
            class="owal panel header right button"
            style="cursor: pointer;"
            @click="closeClicked"
          >
            Close
          </span>
        </div>
      </div>
      
      <div id="camera-container">
        <owal-radio-panel
          name ='detectables'
          :radio-items="detectables"
          :change-function="checkboxFunction"
        />
           
      </div>
    </div>
  </owal-modal>
</template>

<script>
import OwalModal from '@/libraries/owal-ui/modals/OwalModal'
import { mapGetters, mapMutations } from 'vuex'
import OwalRadioPanel from '../../../libraries/owal-ui/inputs/OwalRadioPanel.vue'


export default {
  name: 'OwalDetectionFilter',
  components: {
    OwalModal,
    OwalRadioPanel
  },
  props:["show"],
  data: function () {
    return {
      search: '',
    }
  },
  computed: {
    ...mapGetters({
        detectableTypes: 'events/detectableTypesList'
    }),
    detectables: function () {
        let types = this.detectableTypes

        if (!types) return []

        return types

    }
    // cameras: function () {
    //   let cameras = this.camerasForCurrentDomain

    //   if (!cameras) {
    //     // console.log('Cameras List (InfoPanel.vue): No cameras are available.')
    //     return []
    //   }
    //   let filtered = cameras.filter(camera => camera.description.toLowerCase().includes(this.search.toLowerCase()))

    //   return filtered
    // },
    // categories: function () {
    //   let categories = {}
    //   let cameras = this.camerasForCurrentDomain

    //   if (!cameras) {
    //     return []
    //   }

    //   cameras.map(camera => {
    //     if (camera.category in categories) {
    //       categories[camera.category] += 1
    //     } else {
    //       categories[camera.category] = 1
    //     }
    //   })

    //   const categoriesArray = Object.keys(categories)
    //   const otherIndex = categoriesArray.indexOf('Other')

    //   if (otherIndex > -1) {
    //     categoriesArray.splice(otherIndex, 1)
    //   }

    //   categoriesArray.sort((a, b) => {
    //     const categoryA = a.toLowerCase()
    //     const categoryB = b.toLowerCase()

    //     return categoryA > categoryB ? 1 : (categoryB > categoryA ? -1 : 0)
    //     /*
    //     * equivalent to
    //     *  if (a > b) {
    //     *   return 1
    //     * } else if (a > b) {
    //     *   return -1
    //     * } else {
    //     *   return 0
    //     * }
    //     */
    //   })
    //   return categoriesArray
    // },
  },
  methods: {
      ...mapMutations({
      setFilterDetectable: 'dna/setFilterDetectable',
    }),
    selectCamera: function (cameraId) {
      this.$emit('change', cameraId)
    },
    closeClicked: function () {
      this.$emit('close-clicked') /* deprecated - use close, but keep this for legacy code. */
      this.$emit('close')
    },
    checkboxFunction: function (e) {
      if(e.target.checked) {
        this.setFilterDetectable(e.target.id)
        this.$emit('filterDetectable', e.target.id)
      }
      //this.$emit('close')
      
    }
  },
}

</script>

<style scoped>
.owal.camera.picker.modal {
  display: flex;
  height: 100%;
  overflow: auto;
  padding: 5rem;
}
.owal.camera.picker.panel {
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  max-height: 480px;
  width: 320px;
  background-color: #F3F4F5;
  box-shadow: 0 0 5px #555;
  border-radius: 5px;
}

.owal.panel.header.bar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  width: 100%;
  height: 3.1875rem;
  flex-shrink: 0;
  margin: 0 !important;
  padding: 0 !important;
}

.owal.panel.header.title.bar {
  padding: 0 !important;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  background: #475669;
  color: #EFF2F7;
}

.owal.panel.header.title.bar h3 {
  flex-shrink: 2;
  margin: 0 !important;
  padding: 0 !important;
}

.owal.panel.header.right.button {
  margin: 0 !important;
  margin-right: 1.1rem !important;
  padding: 0 !important;
}

.owal.panel.header.search.bar {
  flex-shrink: 0;
  width:100%;
  height: 44px;
  padding: 0 0.75rem !important;
  margin: 0;
}

#camera-container {
  overflow-y: auto;
  flex: auto;
  justify-content: center;
  padding-bottom: 25px;
}

</style>
